









































































































































































import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { cloneDeep, sortBy } from 'lodash';
import { GridReadyEvent, ValueGetterParams } from '@ag-grid-community/core';
import { AgGridVue } from '@ag-grid-community/vue';
import { VueMaskFilter } from 'v-mask';
import ClientModel from '@/models/crm/client.model';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import LocalizationService from '@/services/localization.service';
import SessionService from '@/services/session.service';
import StateModel from '@/models/state.model';
import CityModel from '@/models/city.model';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { IGridConfig } from '@/interfaces/grid-config.interface';
import Tooltip from '@/components/tooltip.vue';
import ClientService from '@/services/crm/client.service';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IGridCellEvent } from '@/interfaces/grid-cell-clicked.interface';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import { OrigemTypeEnum } from '@/enums/origin-register-type.enum';
import LeadService from '@/services/crm/lead.service';
import LeadModel from '@/models/crm/lead.model';
import CaptureMethodService from '@/services/crm/capture-method.service';
import CaptureMethodModel from '@/models/crm/capture-method.model';
import SettingsService from '@/services/crm/settings.service';

@Component({
  components: {
    AgGridWrapper,
    AgGridVue,
    Tooltip,
  },
})
export default class CrmAdvancedSearch extends Vue {
  @inject(InjectionIdEnum.LocalizationService)
  private localizationService!: LocalizationService;

  @inject(InjectionIdEnum.CrmLeadService)
  private leadService!: LeadService;

  @inject(InjectionIdEnum.CrmCaptureMethodService)
  private captureMethodService!: CaptureMethodService;

  @inject(InjectionIdEnum.CrmClientService)
  private clientService!: ClientService;

  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @Prop({ required: true })
  clientType!: ClientTypeEnum;

  formIsValid = true;

  model: IKeyValue<string | null> = {
    cnpj: null,
    companyName: null,
    clientCode: null,
    legalName: null,
    state: null,
    city: null,
    lead: null,
    contactChannel: null,
    registerOrigin: null,
  };

  stateOptions: StateModel[] = [];

  cityOptions: CityModel[] = [];

  leadOptions: LeadModel[] = [];

  captureMethodOptions: CaptureMethodModel[] = [];

  cityLoading = false;

  grid: GridReadyEvent | null = null;

  gridSettings: IGridConfig = {
    loading: false,
    defaultSort: [{ colId: 'nome', sort: 'asc' }],
    columnDefs: [],
  };

  items: ClientModel[] = [];

  originOptions: { id: number; nome: string }[] = [
    {
      id: OrigemTypeEnum.CRM,
      nome: this.origemCRM,
    },
    {
      id: OrigemTypeEnum.B2B,
      nome: this.origemB2B,
    },
    {
      id: OrigemTypeEnum.FORCAVENDAS,
      nome: this.origemForca,
    },
    {
      id: OrigemTypeEnum.FORCAVENDASTEXTIL,
      nome: this.origemForcaTextil,
    },
    {
      id: OrigemTypeEnum.LANDINGPAGEALPHABETO,
      nome: this.origemLandingPageAlphabeto,
    },
    {
      id: OrigemTypeEnum.RDSTATION,
      nome: this.origemRDStation,
    },
    {
      id: OrigemTypeEnum.CRMINTEGRACAO,
      nome: this.origemCRMIntegracao,
    },
    {
      id: OrigemTypeEnum.SEMORIGEM,
      nome: this.origemNaoDef,
    },
  ];

  async mounted(): Promise<void> {
    const settings = await this.settingsService.getSettingsOrNull();
    if (!settings?.flagExibeOrigemLandingPageAlphabeto) {
      this.originOptions = this.originOptions.filter((x) => x.id !== OrigemTypeEnum.LANDINGPAGEALPHABETO);
    }

    try {
      const states = await this.localizationService.getStates();
      this.stateOptions = states ? sortBy(states, 'nome') : [];

      if (this.isProspectType) {
        const leads = await this.leadService.getLeads();
        this.leadOptions = leads || [];

        const captureMethods = await this.captureMethodService.getCaptureMethods();
        this.captureMethodOptions = captureMethods || [];
      }
    } catch {
      // just empty to continue the execution
    }

    let columnDefs = [
      {
        headerName: `${this.$t('crm.advancedSearch.grid.registerOrigin')}`,
        field: 'origemCadastro',
        valueGetter: (params: ValueGetterParams): string => {
          if (!params.data) {
            return '';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.CRM) {
            return 'CRM';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.B2B) {
            return 'E-commerce B2B';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.FORCAVENDAS) {
            return 'Força de Vendas';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.FORCAVENDASTEXTIL) {
            return 'Força de Vendas Têxtil';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.LANDINGPAGEALPHABETO) {
            return 'LandingPage Alphabeto';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.RDSTATION) {
            return 'RD Station';
          }
          if (params.data.origemCadastro === OrigemTypeEnum.CRMINTEGRACAO) {
            return 'CRM Integração';
          }
          if (params.data.origemCadastro === null
              || params.data.origemCadastro === OrigemTypeEnum.SEMORIGEM) {
            return 'Não identificado';
          }
          return '';
        },
        minWidth: 140,
        maxWidth: 140,
      },
      {
        headerName: `${this.$t('crm.advancedSearch.grid.cnpj')}`,
        field: 'cnpjCpf',
        valueGetter: (params: ValueGetterParams): string => {
          if (!params.data || !params.data.cnpjCpf) {
            return '';
          }
          const mask = params.data.cnpjCpf.length > 11 ? 'NN.NNN.NNN/NNNN-NN' : '###.###.###-##';
          return VueMaskFilter(params.data.cnpjCpf, mask);
        },
        minWidth: 140,
        maxWidth: 140,
      },
      {
        headerName: `${this.$t('crm.advancedSearch.grid.companyName')}`,
        field: 'nomeFantasia',
        minWidth: 130,
        autoHeight: true,
      },
      {
        headerName: `${this.$t('crm.advancedSearch.grid.legalName')}`,
        field: 'nome',
        minWidth: 130,
        autoHeight: true,
      },
      {
        headerName: `${this.$t('crm.advancedSearch.grid.city')}`,
        field: 'cidade',
        autoHeight: true,
      },
      {
        headerName: `${this.$t('crm.advancedSearch.grid.state')}`,
        field: 'estado',
        maxWidth: 70,
      },
    ];

    if (this.isProspectType) {
      columnDefs = [
        {
          headerName: `${this.$t('crm.advancedSearch.grid.clientCode')}`,
          field: 'codCliente',
          maxWidth: 130,
        },
        ...columnDefs,
        {
          headerName: `${this.$t('crm.advancedSearch.grid.leadType')}`,
          field: 'lead.descricao',
          maxWidth: 130,
        },
        {
          headerName: `${this.$t('crm.advancedSearch.grid.contactChannel')}`,
          field: 'formaCaptacao.descricao',
          maxWidth: 130,
        },
      ];
    }

    this.gridSettings.columnDefs = columnDefs;
  }

  onCellClick(event: IGridCellEvent<ClientModel>): void {
    if (!event.data) {
      return;
    }

    this.sessionService.activeClient = event.data;
    if (this.clientType === ClientTypeEnum.Client) {
      this.sessionService.clientType = ClientTypeEnum.Client;
    } else {
      this.sessionService.clientType = ClientTypeEnum.Prospect;
    }

    this.$emit('select', event.data);
  }

  @Emit('cancel')
  onCancel(): void {
    this.formIsValid = false;
  }

  async onStateChange(uf: string): Promise<void> {
    this.cityOptions = [];
    this.model.city = null;

    if (!uf) {
      return;
    }

    this.cityLoading = true;
    try {
      this.cityOptions = sortBy(await this.localizationService.getCities(uf), 'nome');
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.cityLoading = false;
    }
  }

  async onSearch(): Promise<void> {
    this.gridSettings.loading = true;
    try {
      const params = cloneDeep(this.model);

      if (params.cnpj) {
        params.cnpj = params.cnpj.replace(/[^0-9A-Za-z]/g, '');
      }

      this.items = await this.clientService.advancedSearch(params, this.clientType);
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.gridSettings.loading = false;
    }
  }

  onExport(): void {
    if (this.grid) {
      this.grid.api.exportDataAsExcel({
        allColumns: true,
        author: 'IBtech',
        sheetName: this.isProspectType ? 'Prospects' : 'Clientes',
        fileName: this.isProspectType
          ? ClientService.generateProspectExportFilename(new Date())
          : ClientService.generateClientExportFilename(new Date()),
      });
    }
  }

  get isProspectType(): boolean {
    return this.clientType === ClientTypeEnum.Prospect;
  }

  get isClientType(): boolean {
    return this.clientType === ClientTypeEnum.Client;
  }

  get origemCRM(): string {
    return this.$t('crm.advancedSearch.origemOptions.crm').toString();
  }

  get origemB2B(): string {
    return this.$t('crm.advancedSearch.origemOptions.b2b').toString();
  }

  get origemForca(): string {
    return this.$t('crm.advancedSearch.origemOptions.forcaDeVendas').toString();
  }

  get origemForcaTextil(): string {
    return this.$t('crm.advancedSearch.origemOptions.forcaDeVendasTextil').toString();
  }

  get origemLandingPageAlphabeto(): string {
    return this.$t('crm.advancedSearch.origemOptions.landingPageAlphabeto').toString();
  }

  get origemRDStation(): string {
    return this.$t('crm.advancedSearch.origemOptions.rdStation').toString();
  }

  get origemCRMIntegracao(): string {
    return this.$t('crm.advancedSearch.origemOptions.crmIntegracao').toString();
  }

  get origemNaoDef(): string {
    return this.$t('crm.advancedSearch.origemOptions.naoIdentificado').toString();
  }

  get cnpjCpfMask(): string {
    if (this.model.cnpj) {
      if (this.model.cnpj.length === 17 || (this.model.cnpj.length === 14 && !this.model.cnpj.includes('.'))) {
        return 'NN.NNN.NNN/NNNN-NN';
      } if (this.model.cnpj.length === 11
      || (this.model.cnpj.length === 8 && !this.model.cnpj.includes('.'))) {
        return '###.###.###-##';
      }
    }
    return '';
  }
}
